import { useState } from 'react'
import { AtendimentoGestaoListSearchComponent } from './AtendimentoGestaoListSearchComponent'
import { AtendimentoGestaoListToolbar } from './AtendimentoGestaoListToolbar'

export const AtendimentoGestaoListHeader = () => {
  // Exportar sem período destaca os campos de período como obrigatórios.
  const [forceDateRangeError, setForceDateRangeError] = useState(false)

  return (
    <div className='card-header border-0 pt-6'>
      <AtendimentoGestaoListSearchComponent
        forceDateRangeError={forceDateRangeError}
        actions={
          <AtendimentoGestaoListToolbar onPeriodoIncompleto={() => setForceDateRangeError(true)} />
        }
      />
    </div>
  )
}
